import styled from "styled-components";
import css from "@styled-system/css";

export const Title = styled("div")(
  css({
    fontSize: [2, 3],
    fontWeight: "bold",
    mb: 30,
  })
);

export const Description = styled("p")(
  css({
    fontSize: [1, 2],
    my: 0,
  })
);

export const Card = styled("div")({
  boxSizing: "border-box",
  padding: 30,
  background: "#fff",
  borderRadius: "30px",
});

export const Picture = styled("div")(
  { backgroundImage: ({ $src }) => `url(${$src})` },
  css({
    position: "relative",
    backgroundPosition: "center",
    backgroundSize: "cover",

    mx: -30,
    my: 30,

    ":after": {
      content: "''",
      display: "block",
      paddingTop: "46%",
    },
  })
);
